import React from 'react';
import './toogles.css';
import useScreenShareToggle from '../../../hooks/useScreenShareToggle';
import useScreenShareParticipant from '../../../hooks/useScreenShareParticipant';
import useVideoContext from '../../../hooks/useVideoContext';
import { useVideoRoomI18nProvider, VideoRoomI18nMessage } from '../../../components/VideoRoomI18n';
import Fab from '../Fab';
import Tooltip from '../Tooltip';
import ScreenShare from '../../../icons/ScreenShare';
import StopScreenShare from '../../../icons/StopScreenShare';
export var SCREEN_SHARE_TEXT = 'Share Screen';
export var STOP_SCREEN_SHARE_TEXT = 'Stop Sharing Screen';
export var SHARE_IN_PROGRESS_TEXT = 'Cannot share screen when another user is sharing';
export var SHARE_NOT_SUPPORTED_TEXT = 'Screen sharing is not supported with this browser';
export default function ToggleScreenShareButton(_ref) {
  var disabled = _ref.disabled;

  var _useVideoContext = useVideoContext(),
      room = _useVideoContext.room,
      allowScreenShare = _useVideoContext.allowScreenShare,
      themeOptions = _useVideoContext.themeOptions;

  var _useScreenShareToggle = useScreenShareToggle(),
      isScreenShared = _useScreenShareToggle[0],
      toggleScreenShare = _useScreenShareToggle[1];

  var screenShareParticipant = useScreenShareParticipant();
  var disableScreenShareButton = screenShareParticipant && screenShareParticipant !== room.localParticipant;
  var isScreenShareSupported = navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia;
  var isDisabled = disabled || disableScreenShareButton || !isScreenShareSupported;

  var _useVideoRoomI18nProv = useVideoRoomI18nProvider(),
      format = _useVideoRoomI18nProv.format;

  var tooltipMessage = format(VideoRoomI18nMessage.cta_start_screen_share);

  if (isScreenShared) {
    tooltipMessage = format(VideoRoomI18nMessage.cta_stop_screen_share);
  }

  if (disableScreenShareButton) {
    tooltipMessage = format(VideoRoomI18nMessage.screen_share_in_progress);
  }

  if (!isScreenShareSupported) {
    tooltipMessage = format(VideoRoomI18nMessage.screen_share_not_supported);
  }

  return allowScreenShare && /*#__PURE__*/React.createElement(Tooltip, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "tooltip-title"
    }, tooltipMessage)
  }, /*#__PURE__*/React.createElement("span", {
    id: "share-button"
  }, /*#__PURE__*/React.createElement(Fab, {
    icon: isScreenShared ? /*#__PURE__*/React.createElement(StopScreenShare, {
      fill: "white",
      className: "control-size"
    }) : /*#__PURE__*/React.createElement(ScreenShare, {
      fill: "black",
      className: "control-size"
    }),
    theme: themeOptions,
    onClick: toggleScreenShare,
    disabled: isDisabled,
    isIconEnabled: null,
    size: "small"
  })));
}